
// if (!customElements.get('black-friday-deals-products')) {
//   class BlackFridayDealsProducts extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       this.tabButtons = this.querySelectorAll('.bf-tab-btn');
//       this.tabPanels  = this.querySelectorAll('.bf-tab-panel');
//       this.filterCheckboxes = document.querySelectorAll('.bfcm-filter-checkbox');
//       this.priceDropdown = document.querySelector('.bfcm-dropdown[data-dropdown]');
//       this.clearFiltersBtn = this.querySelector('.remove-filter-btn');
//       this.mobileFiltersBtn = this.querySelector('#mobile-filters-btn');
//       this.filterPanel = this.querySelector('.black-friday-deals-products-filter-desktop');

//       if (this.tabButtons.length > 0) {
//         this.activateTab(this.tabButtons[0].dataset.tab);
//       }

//       // Tab click
//       this.tabButtons.forEach(btn => {
//         btn.addEventListener('click', () => {
//           this.activateTab(btn.dataset.tab);
//           this.applyFilters();
//         });
//       });

//       // Checkbox change
//       this.filterCheckboxes.forEach(cb => cb.addEventListener('change', () => this.applyFilters()));

//       // Price dropdown click
//       this.priceDropdown.querySelectorAll("li").forEach(item => {
//         item.addEventListener("click", () => {
//           this.priceDropdown.querySelectorAll("li").forEach(li => li.classList.remove("active"));
//           item.classList.add("active");
//           this.applyFilters();
//         });
//       });

//       // Clear Filters Button Click
//       if (this.clearFiltersBtn) {
//         this.clearFiltersBtn.addEventListener('click', () => {
//           this.filterCheckboxes.forEach(cb => cb.checked = false);
//           this.priceDropdown.querySelectorAll("li").forEach(li => li.classList.remove("active"));
//           this.priceDropdown.querySelector('li[data-value="Any Price"]').classList.add("active");
//           this.applyFilters();
//         });
//       }

//       // Mobile filters button toggle
//       if (this.mobileFiltersBtn && this.filterPanel) {
//         this.mobileFiltersBtn.addEventListener('click', () => {
//           this.filterPanel.classList.toggle('active');
//         });
//       }

//       this.applyFilters();
//     }

//     activateTab(tabId) {
//       this.tabButtons.forEach(btn => {
//         btn.classList.toggle('active', btn.dataset.tab === tabId);
//       });
//       this.tabPanels.forEach(panel => {
//         panel.style.display = (panel.id === tabId) ? 'flex' : 'none';
//       });
//     }

//     getSelectedFilters() {
//       return Array.from(this.filterCheckboxes)
//         .filter(cb => cb.checked)
//         .map(cb => cb.value);
//     }

//     getSelectedPriceRange() {
//       const activeItem = this.priceDropdown.querySelector('.active');
//       return activeItem && activeItem.dataset.value !== "Any Price" ? activeItem.dataset.value : null;
//     }

//     productMatchesPrice(price, range) {
//       switch (range) {
//         case "Under $100": return price < 100;
//         case "$100 - $200": return price >= 100 && price <= 200;
//         case "$200 - $300": return price >= 200 && price <= 300;
//         case "Over $300": return price > 300;
//         default: return true;
//       }
//     }

//     applyFilters() {
//       const activeFilters = this.getSelectedFilters().map(f => f.toLowerCase());
//       const selectedRange = this.getSelectedPriceRange();

//       this.querySelectorAll('.bf-tab-panel').forEach(panel => {
//         panel.querySelectorAll('.bf-tab-product-card').forEach(card => {
//           const productFilters = card.dataset.bfcmProductFilter
//             ? card.dataset.bfcmProductFilter.toLowerCase().replace(/-/g, ',').split(',').map(v => v.trim())
//             : [];
//           const productPrice = parseFloat(card.dataset.bfcmProductPrice);
//           const matchesFilter = activeFilters.length === 0 || activeFilters.some(f => productFilters.includes(f));
//           const matchesPrice = selectedRange ? this.productMatchesPrice(productPrice, selectedRange) : true;
//           card.style.display = (matchesFilter && matchesPrice) ? '' : 'none';
//         });
//       });

//       // Show/hide Clear All button
//       if (this.clearFiltersBtn) {
//         const anyCheckboxChecked = Array.from(this.filterCheckboxes).some(cb => cb.checked);
//         const priceActive = selectedRange !== null;
//         this.clearFiltersBtn.style.display = (anyCheckboxChecked || priceActive) ? 'flex' : 'none';
//       }

//       // Update mobile filter count
//       if (this.mobileFiltersBtn) {
//         const count = Array.from(this.filterCheckboxes).filter(cb => cb.checked).length + (selectedRange ? 1 : 0);
//         const countSpan = this.mobileFiltersBtn.querySelector('.mobile-filters-count');
//         if (count > 0) {
//           countSpan.textContent = `(${count})`;
//         } else {
//           countSpan.textContent = ''; // empty if no filters
//         }
//       }
//     }
//   }

//   customElements.define('black-friday-deals-products', BlackFridayDealsProducts);
// }
if (!customElements.get('black-friday-deals-products')) {
  class BlackFridayDealsProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabButtons = this.querySelectorAll('.bf-tab-btn');
      this.tabPanels  = this.querySelectorAll('.bf-tab-panel');
      this.filterCheckboxes = this.querySelectorAll('.bfcm-filter-checkbox');
      this.priceDropdown = this.querySelector('.bfcm-dropdown[data-dropdown]');
      this.clearFiltersBtn = this.querySelector('.remove-filter-btn');
      this.mobileFiltersBtn = this.querySelector('#mobile-filters-btn');
      this.filterPanel = this.querySelector('.black-friday-deals-products-filter-desktop');

      if (this.tabButtons.length > 0) {
        this.activateTab(this.tabButtons[0].dataset.tab);
      }

      // Tab click
      this.tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.activateTab(btn.dataset.tab);
          this.applyFilters();
        });
      });

      // Checkbox change
      this.filterCheckboxes.forEach(cb => cb.addEventListener('change', () => this.applyFilters()));

      // Integrate dropdown UI
      if (this.priceDropdown) {
        const selected = this.priceDropdown.querySelector("[data-dropdown-selected]");
        const listItems = this.priceDropdown.querySelectorAll("li");

        selected.addEventListener("click", (e) => {
          e.stopPropagation();
          this.priceDropdown.classList.toggle("active");
        });

        listItems.forEach(item => {
          item.addEventListener("click", (e) => {
            e.stopPropagation();
            listItems.forEach(i => i.classList.remove("active"));
            item.classList.add("active");
            selected.innerHTML = item.innerHTML + ' <span class="dropdown-arrow"></span>';
            this.priceDropdown.classList.remove("active");
            this.applyFilters(); // <-- Important: update filters when dropdown changes
          });
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", () => {
          this.priceDropdown.classList.remove("active");
        });
      }

      // Clear Filters Button Click
      if (this.clearFiltersBtn) {
        this.clearFiltersBtn.addEventListener('click', () => {
          this.filterCheckboxes.forEach(cb => cb.checked = false);
          this.priceDropdown.querySelectorAll("li").forEach(li => li.classList.remove("active"));
          this.priceDropdown.querySelector('li[data-value="Any Price"]').classList.add("active");
          this.priceDropdown.querySelector("[data-dropdown-selected]").innerHTML =
            'Any Discount <span class="dropdown-arrow"></span>';
          this.applyFilters();
        });
      }

      // Mobile filters button toggle
      if (this.mobileFiltersBtn && this.filterPanel) {
        this.mobileFiltersBtn.addEventListener('click', () => {
          this.filterPanel.classList.toggle('active');
        });
      }

      this.applyFilters();
    }

    activateTab(tabId) {
      this.tabButtons.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.tab === tabId);
      });
      this.tabPanels.forEach(panel => {
        panel.style.display = (panel.id === tabId) ? 'flex' : 'none';
      });
    }

    getSelectedFilters() {
      return Array.from(this.filterCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);
    }

    getSelectedPriceRange() {
      const activeItem = this.priceDropdown.querySelector('.active');
      return activeItem && activeItem.dataset.value !== "Any Price" ? activeItem.dataset.value : null;
    }

    productMatchesPrice(price, range) {
      switch (range) {
        case "Under 10": return price < 10;
        case "10 - 20": return price >= 10 && price <= 20;
        case "20 - 30": return price >= 20 && price <= 30;
        case "30 - 40": return price >= 30 && price <= 40;
        case "40 - 50": return price >= 40 && price <= 50;
        case "50 - 60": return price >= 50 && price <= 60;
        case "60 - 70": return price >= 60 && price <= 70;
        case "70 - 80": return price >= 70 && price <= 80;
        case "80 - 90": return price >= 80 && price <= 90;
        case "Over 90": return price > 90;
        default: return true;
      }
    }

    applyFilters() {
      const activeFilters = this.getSelectedFilters().map(f => f.toLowerCase());
      const selectedRange = this.getSelectedPriceRange();

      this.querySelectorAll('.bf-tab-panel').forEach(panel => {
        panel.querySelectorAll('.bf-tab-product-card').forEach(card => {
          const productFilters = card.dataset.bfcmProductFilter
            ? card.dataset.bfcmProductFilter.toLowerCase().replace(/-/g, ',').split(',').map(v => v.trim())
            : [];
          const productPrice = parseFloat(card.dataset.bfcProductDiscount);
          const matchesFilter = activeFilters.length === 0 || activeFilters.some(f => productFilters.includes(f));
          const matchesPrice = selectedRange ? this.productMatchesPrice(productPrice, selectedRange) : true;
          card.style.display = (matchesFilter && matchesPrice) ? '' : 'none';
        });
      });

      // Show/hide Clear All button
      if (this.clearFiltersBtn) {
        const anyCheckboxChecked = Array.from(this.filterCheckboxes).some(cb => cb.checked);
        const priceActive = selectedRange !== null;
        this.clearFiltersBtn.style.display = (anyCheckboxChecked || priceActive) ? 'flex' : 'none';
      }

      // Update mobile filter count
      if (this.mobileFiltersBtn) {
        const count = Array.from(this.filterCheckboxes).filter(cb => cb.checked).length + (selectedRange ? 1 : 0);
        const countSpan = this.mobileFiltersBtn.querySelector('.mobile-filters-count');
        if (count > 0) {
          countSpan.textContent = `(${count})`;
        } else {
          countSpan.textContent = '';
        }
      }
    }
  }

  customElements.define('black-friday-deals-products', BlackFridayDealsProducts);
}
